const initialSevenArtsList = [
  { id: 0, title: 'Big Bellies', seen: false },
  { id: 1, title: 'Lunar Landscape', seen: false },
  { id: 2, title: 'Terracota Army', seen: true },
];

export { initialSevenArtsList };
